import React, { FC, useEffect } from 'react';
import { OrdersCtxProvider } from './context/orders';
import { CouriersCtxProvider } from './context/couriers';
import { AccordionCtxProvider } from '@shared/context/accordion';
import {
  DeliveryMenuNavigationItem,
  useDeliveryNavigationActions,
  useDeliveryNavigationState,
} from './context/delivery-navigation';
import InfoBar from './components/InfoBar';
import MobileBottomNavigation from './components/MobileBottomNavigation';
import Map from './components/Map';
import useStyles from './styles';
import SSEEventsService from '@src/shared/services/sse-events';
import useSSEErrorHandler from './hooks/use-sse-error-handler';
import { useFeatureFlaggingActions } from '@src/shared/context/featureflaging';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import { DrawerType } from '@src/shared/context/inside-drawer';
import InsideDrawer, {
  IDrawerSettings,
} from '@src/shared/components/InsideDrawer';
import OrderDetailTabs from './components/OrderDetailTabs';
import { OrderFilterCtxProvider } from './context/order-filter';
import OrderCardInitialTutorial from '@src/shared/components/Tutorial/tutorials/OrderCardInitialTutorial';
import { SSEInitializer } from './components/SSEInitializer';
import { isPWA, AxiosOnlineCheckerInstance } from '@src/shared/utils';
const DeliveriesPage: FC = () => {
  const classes = useStyles();
  const { isMobileDevice } = useDeviceDetect();
  const isMobileScreen = isMobileDevice;
  const { selectedNavigationItem } = useDeliveryNavigationState();
  const { setActiveMenu } = useDeliveryNavigationActions();
  const { setIsTestRestaurant } = useFeatureFlaggingActions();
  const { handleSSEError, SSERetryActive, SSEerror, SSERetry } =
    useSSEErrorHandler();

  const drawerSettings: IDrawerSettings = {
    drawerVariant: 'persistent',
    fullSize: false,
    customClose: false,
    anchor: 'right',
  };

  useEffect(() => {
    if (isMobileScreen) {
      setActiveMenu(DeliveryMenuNavigationItem.Map);
    }
  }, [isMobileScreen]);

  useEffect(() => {
    const SSETokenErrorSource = SSEEventsService.subscribeToSSETokenError(
      (SSEConsumer, errorObject) => {
        AxiosOnlineCheckerInstance.start(5000);
        handleSSEError(SSEConsumer, errorObject);
      }
    );

    const SSEOpenEventSource = SSEEventsService.subscribeToSSEOpen(async () => {
      if (SSEerror) {
        SSERetry(false);
      }
    });
    return () => {
      SSETokenErrorSource.unsubscribe();
      SSEOpenEventSource.unsubscribe();
    };
  }, [SSERetryActive, SSEerror]);

  useEffect(() => {
    setIsTestRestaurant(true); //TODO Refactor
  }, []);

  return (
    <OrdersCtxProvider>
      <OrderFilterCtxProvider>
        <CouriersCtxProvider>
          <AccordionCtxProvider>
            <SSEInitializer SSEerror={SSEerror} />
            <OrderCardInitialTutorial />
            <div
              className={`${classes.wrapper} ${isPWA() ? 'pwaWrapper' : ''}`}
            >
              {isMobileScreen ? (
                <>
                  <div className={classes.fixedNavigationBlock}>
                    <MobileBottomNavigation
                      navigateTo={selectedNavigationItem}
                    />
                  </div>

                  {selectedNavigationItem !== DeliveryMenuNavigationItem.Map ? (
                    <InfoBar
                      isMobileViewActive={isMobileScreen}
                      infoSection={selectedNavigationItem}
                    />
                  ) : null}
                </>
              ) : (
                <InfoBar />
              )}
              {!SSEerror && (
                <Map
                  isMobileViewActive={isMobileScreen}
                  selectedNavigationItem={selectedNavigationItem}
                />
              )}
            </div>
            <InsideDrawer
              type={DrawerType.ORDER_CARD}
              titleI18nKey=""
              settings={drawerSettings}
            >
              <OrderDetailTabs />
            </InsideDrawer>
          </AccordionCtxProvider>
        </CouriersCtxProvider>
      </OrderFilterCtxProvider>
    </OrdersCtxProvider>
  );
};

export default DeliveriesPage;
